// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.HeaderCart_carticon__0rI5J {
    cursor: pointer;
    display: flex;
    align-items: center;
    position: relative;
    margin-right: 25px;
    top: 2px;
}

/* Số lượng giỏ hàng */
.HeaderCart_cartcount__2LGSM {
    background: red;
    color: white;
    border-radius: 50%;
    padding: 2px 6px;
    font-size: 12px;
    position: absolute;
    top: -5px;
    right: -20px;
}

.HeaderCart_cartdropdown__an9rS {
    position: absolute;
    top: 65px;
    
    right: 250px;
    background: white;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
    width: 250px;
    z-index: 1000;
    display: block; /* Giữ cho dropdown luôn hiển thị */
    opacity: 0; /* Ban đầu ẩn dropdown */
    visibility: hidden; /* Ban đầu ẩn dropdown */
    transform: translateY(-5px); /* Hiệu ứng mượt mà */
    transition: opacity 0.5s ease, transform 0.3s ease, visibility 0s linear 0.5s; /* Tăng thời gian opacity và giữ hiệu ứng mượt mà */
}

/* Hiển thị dropdown khi hover vào cart-icon hoặc cart-dropdown */
.HeaderCart_carticon__0rI5J:hover + .HeaderCart_cartdropdown__an9rS,
.HeaderCart_cartdropdown__an9rS:hover {
    opacity: 1;
    visibility: visible; /* Làm cho dropdown hiện lên */
    transform: translateY(0); /* Di chuyển dropdown về vị trí bình thường */
}

/* Danh sách sản phẩm trong giỏ hàng */
.HeaderCart_cartitems__GYH7y {
    max-height: 270px;
    overflow-y: auto;
    margin: 0;
    padding: 0;
    list-style: none;
}

/* Mỗi sản phẩm trong giỏ hàng */
.HeaderCart_cartitem__VDwyD {
    display: flex;
    justify-content: space-between;  /* Căn giữa các sản phẩm và nút xóa */
    align-items: center;
    padding: 10px;
    border-bottom: 1px solid #eee;
}

.HeaderCart_cartitemdetails__HCMvM {
    display: flex;
    flex-direction: column; 
    justify-content: space-between;
    width: 100%;
}

.HeaderCart_itemname__nSGus {
    font-weight: bold;
    font-size: 14px;
}

.HeaderCart_iteminfo__jjR-0 {
    display: flex;
    justify-content: space-between;
    font-size: 12px;
    color: #555;
}

.HeaderCart_removeitembtn__5negu {
    background: none;
    border: none;
    color: red;
    font-size: 15px;
    cursor: pointer;
}

.HeaderCart_carttotal__53JuC {
    padding: 10px;
    text-align: right;
    font-weight: bold;
}

.HeaderCart_cartbuttons__PIFu6 {
    display: flex;
    justify-content: space-between; 
    padding: 10px;
    border-top: 1px solid #eee;
    justify-content: center;  


}

.HeaderCart_cartbuttons__PIFu6 button {
    background: #007bff;
    color: white;
    border: none;
    padding: 5px 10px;
    cursor: pointer;
    border-radius: 4px;
    justify-content: center;  
    width: "200px";


}

.HeaderCart_cartbuttons__PIFu6 button:hover {
    background: #0056b3;
}

.HeaderCart_cartdropdown__an9rS,
.HeaderCart_carticon__0rI5J {
    pointer-events: auto; 
}

.HeaderCart_cartcontainer__eP9SM {
    position: relative;
    display: inline-block;
}

.HeaderCart_carticon__0rI5J:hover ~ .HeaderCart_cartdropdown__an9rS,
.HeaderCart_cartdropdown__an9rS:hover {
    visibility: visible;
    opacity: 1;
}
.HeaderCart_no-hover__sAOEv:hover {
    background-color: transparent !important;
    color: inherit !important;
    text-decoration: none !important;
}
`, "",{"version":3,"sources":["webpack://./src/components/layout/Header/HeaderCart.module.css"],"names":[],"mappings":"AAAA;IACI,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,kBAAkB;IAClB,QAAQ;AACZ;;AAEA,sBAAsB;AACtB;IACI,eAAe;IACf,YAAY;IACZ,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,kBAAkB;IAClB,SAAS;IACT,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,SAAS;;IAET,YAAY;IACZ,iBAAiB;IACjB,yCAAyC;IACzC,YAAY;IACZ,aAAa;IACb,cAAc,EAAE,mCAAmC;IACnD,UAAU,EAAE,wBAAwB;IACpC,kBAAkB,EAAE,wBAAwB;IAC5C,2BAA2B,EAAE,qBAAqB;IAClD,6EAA6E,EAAE,mDAAmD;AACtI;;AAEA,iEAAiE;AACjE;;IAEI,UAAU;IACV,mBAAmB,EAAE,8BAA8B;IACnD,wBAAwB,EAAE,6CAA6C;AAC3E;;AAEA,sCAAsC;AACtC;IACI,iBAAiB;IACjB,gBAAgB;IAChB,SAAS;IACT,UAAU;IACV,gBAAgB;AACpB;;AAEA,gCAAgC;AAChC;IACI,aAAa;IACb,8BAA8B,GAAG,qCAAqC;IACtE,mBAAmB;IACnB,aAAa;IACb,6BAA6B;AACjC;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,8BAA8B;IAC9B,WAAW;AACf;;AAEA;IACI,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,eAAe;IACf,WAAW;AACf;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,UAAU;IACV,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,iBAAiB;IACjB,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,aAAa;IACb,0BAA0B;IAC1B,uBAAuB;;;AAG3B;;AAEA;IACI,mBAAmB;IACnB,YAAY;IACZ,YAAY;IACZ,iBAAiB;IACjB,eAAe;IACf,kBAAkB;IAClB,uBAAuB;IACvB,cAAc;;;AAGlB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;;IAEI,oBAAoB;AACxB;;AAEA;IACI,kBAAkB;IAClB,qBAAqB;AACzB;;AAEA;;IAEI,mBAAmB;IACnB,UAAU;AACd;AACA;IACI,wCAAwC;IACxC,yBAAyB;IACzB,gCAAgC;AACpC","sourcesContent":[".carticon {\n    cursor: pointer;\n    display: flex;\n    align-items: center;\n    position: relative;\n    margin-right: 25px;\n    top: 2px;\n}\n\n/* Số lượng giỏ hàng */\n.cartcount {\n    background: red;\n    color: white;\n    border-radius: 50%;\n    padding: 2px 6px;\n    font-size: 12px;\n    position: absolute;\n    top: -5px;\n    right: -20px;\n}\n\n.cartdropdown {\n    position: absolute;\n    top: 65px;\n    \n    right: 250px;\n    background: white;\n    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);\n    width: 250px;\n    z-index: 1000;\n    display: block; /* Giữ cho dropdown luôn hiển thị */\n    opacity: 0; /* Ban đầu ẩn dropdown */\n    visibility: hidden; /* Ban đầu ẩn dropdown */\n    transform: translateY(-5px); /* Hiệu ứng mượt mà */\n    transition: opacity 0.5s ease, transform 0.3s ease, visibility 0s linear 0.5s; /* Tăng thời gian opacity và giữ hiệu ứng mượt mà */\n}\n\n/* Hiển thị dropdown khi hover vào cart-icon hoặc cart-dropdown */\n.carticon:hover + .cartdropdown,\n.cartdropdown:hover {\n    opacity: 1;\n    visibility: visible; /* Làm cho dropdown hiện lên */\n    transform: translateY(0); /* Di chuyển dropdown về vị trí bình thường */\n}\n\n/* Danh sách sản phẩm trong giỏ hàng */\n.cartitems {\n    max-height: 270px;\n    overflow-y: auto;\n    margin: 0;\n    padding: 0;\n    list-style: none;\n}\n\n/* Mỗi sản phẩm trong giỏ hàng */\n.cartitem {\n    display: flex;\n    justify-content: space-between;  /* Căn giữa các sản phẩm và nút xóa */\n    align-items: center;\n    padding: 10px;\n    border-bottom: 1px solid #eee;\n}\n\n.cartitemdetails {\n    display: flex;\n    flex-direction: column; \n    justify-content: space-between;\n    width: 100%;\n}\n\n.itemname {\n    font-weight: bold;\n    font-size: 14px;\n}\n\n.iteminfo {\n    display: flex;\n    justify-content: space-between;\n    font-size: 12px;\n    color: #555;\n}\n\n.removeitembtn {\n    background: none;\n    border: none;\n    color: red;\n    font-size: 15px;\n    cursor: pointer;\n}\n\n.carttotal {\n    padding: 10px;\n    text-align: right;\n    font-weight: bold;\n}\n\n.cartbuttons {\n    display: flex;\n    justify-content: space-between; \n    padding: 10px;\n    border-top: 1px solid #eee;\n    justify-content: center;  \n\n\n}\n\n.cartbuttons button {\n    background: #007bff;\n    color: white;\n    border: none;\n    padding: 5px 10px;\n    cursor: pointer;\n    border-radius: 4px;\n    justify-content: center;  \n    width: \"200px\";\n\n\n}\n\n.cartbuttons button:hover {\n    background: #0056b3;\n}\n\n.cartdropdown,\n.carticon {\n    pointer-events: auto; \n}\n\n.cartcontainer {\n    position: relative;\n    display: inline-block;\n}\n\n.carticon:hover ~ .cartdropdown,\n.cartdropdown:hover {\n    visibility: visible;\n    opacity: 1;\n}\n.no-hover:hover {\n    background-color: transparent !important;\n    color: inherit !important;\n    text-decoration: none !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"carticon": `HeaderCart_carticon__0rI5J`,
	"cartcount": `HeaderCart_cartcount__2LGSM`,
	"cartdropdown": `HeaderCart_cartdropdown__an9rS`,
	"cartitems": `HeaderCart_cartitems__GYH7y`,
	"cartitem": `HeaderCart_cartitem__VDwyD`,
	"cartitemdetails": `HeaderCart_cartitemdetails__HCMvM`,
	"itemname": `HeaderCart_itemname__nSGus`,
	"iteminfo": `HeaderCart_iteminfo__jjR-0`,
	"removeitembtn": `HeaderCart_removeitembtn__5negu`,
	"carttotal": `HeaderCart_carttotal__53JuC`,
	"cartbuttons": `HeaderCart_cartbuttons__PIFu6`,
	"cartcontainer": `HeaderCart_cartcontainer__eP9SM`,
	"no-hover": `HeaderCart_no-hover__sAOEv`
};
export default ___CSS_LOADER_EXPORT___;
